"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakdownGroups = breakdownGroups;
const GROUPS = [
    { title: 'Labour', code: '001 · 011 · 031', categories: ['labour', 'overtime', 'foreman', 'abseil', 'allowance'] },
    { title: 'Paint', code: '021', categories: ['paint', 'consumables'] },
    { title: 'Hire/Access Equipment', code: '041', categories: ['hire'] },
    { title: 'Prelims incl. Minor Contractors', code: '051', categories: ['otherTrades', 'fuelLevy'] },
];
/** Every breakdown line in exactly one group, in the template's order. */
function breakdownGroups(option) {
    return GROUPS.map(({ title, code, categories }) => {
        const lines = option.breakdown.filter((line) => categories.includes(line.category));
        return { title, code, lines, sell: lines.reduce((sum, l) => sum + l.sell, 0), cost: lines.reduce((sum, l) => sum + l.cost, 0) };
    });
}
